import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import { ConfigSelectors } from '../config';
import ddt from '@wix/da-ddt';
import { CANCEL } from 'redux-saga';
import { getPublicSession } from '../publicSession/selectors';
import { flagEnabled } from '../redux/flags/selectors';
const CANONICAL_XHR_NAPI_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
const LOCAL_XHR_NAPI_ENDPOINT = 'https://www.deviantart.lan/_napi/shared_api/';
const CANONICAL_XHR_PUPPY_ENDPOINT = 'https://www.deviantart.com/_puppy/';
const LOCAL_XHR_PUPPY_ENDPOINT = 'https://www.deviantart.lan/_puppy/';
function getFakeResponse(response) {
    if (process.env.NODE_ENV === 'test') {
        return response;
    }
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(response), 1000);
    });
}
function getApiResponse(options) {
    const cancelTokenSource = axios.CancelToken.source();
    const promise = axios.request(options.enableCancellation ? _object_spread_props(_object_spread({}, options), {
        cancelToken: cancelTokenSource.token
    }) : options).then((response)=>{
        return response.data;
    }).catch(()=>{
        return false;
    });
    // redux saga calls this special prop when it cancel the outer saga E.g. takeLatest
    if (options.enableCancellation) {
        promise[CANCEL] = ()=>cancelTokenSource.cancel();
    }
    return promise;
}
function* configureOptions(options) {
    var _session_device, _session;
    // CSRF
    const csrf = yield select(ConfigSelectors.key('csrfToken'));
    if (options.method && options.method.toLowerCase() === 'post') {
        if (options.data === undefined) {
            options.data = {};
        }
        options.data['csrf_token'] = csrf;
    } else {
        if (options.params === undefined) {
            options.params = {};
        }
        options.params['csrf_token'] = csrf;
    }
    const withCreds = yield select(ConfigSelectors.key('withCredentials'));
    if (withCreds) {
        options.withCredentials = true;
    }
    // Accept header image support
    const session = yield select(getPublicSession);
    if ((_session = session) === null || _session === void 0 ? void 0 : (_session_device = _session.device) === null || _session_device === void 0 ? void 0 : _session_device.supportsWebp) {
        options.headers = _object_spread_props(_object_spread({}, options.headers), {
            Accept: 'application/json, text/plain, image/webp, */*'
        });
    }
    return options;
}
function* runFake(fakeResponse, options) {
    // Using node env so we strip for prod bundle sdf sdf sdf
    if (process.env.NODE_ENV !== 'production') {
        if (fakeResponse !== undefined) {
            const doFake = yield select(ConfigSelectors.key('fakeApiRequests'));
            if (doFake) {
                ddt.log('saga', `Faked XHR for: ${options.url}`, options, fakeResponse(options));
                const result = yield call(getFakeResponse, fakeResponse(options));
                return result;
            }
        }
    }
}
export function isApiError(response) {
    return response.error || response.errorCode;
}
/**
 * TODO once everything is ported to puppy, rename this to requestNapi
 * Calls napi, this one you probably don't need, use puppy instead
 */ export function* request(options, fakeResponse) {
    // Routing
    // local dev goes to sharedApiBasePath which hits the express middlewares locally
    // xhr local goes to the VM
    // canonical goes to the xhr-server
    if (options.baseURL === undefined) {
        // Handle prod vs local endpoint routing
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            options.baseURL = yield select(ConfigSelectors.key('sharedApiBasePath'));
        // Local full docker helper
        } else if (window['__XHR_LOCAL__']) {
            options.baseURL = LOCAL_XHR_NAPI_ENDPOINT;
        // Production goes to the xhr server
        } else {
            options.baseURL = CANONICAL_XHR_NAPI_ENDPOINT;
        }
    }
    options = yield call(configureOptions, options);
    const fake = yield call(runFake, fakeResponse, options);
    if (fake) {
        return fake;
    }
    return yield call(getApiResponse, options);
}
/**
 * Calls puppy, this is the one you want in 99% of cases
 */ export function* requestPuppy(options, fakeResponse, papiBase = 'dashared') {
    // Feature protection
    const isPublicPapi = yield select(flagEnabled, 'public_papi');
    if (!isPublicPapi) {
        return yield call(request, options, fakeResponse);
    }
    // Puppy needs the
    if (papiBase) {
        options.url = `${papiBase}/${options.url}`;
    }
    // Routing
    // local dev hits local nodejs proxy to deal with http -> https
    // vm hits vm
    // canonical hits puppy
    if (options.baseURL === undefined) {
        // Handle prod vs local endpoint routing
        if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
            options.baseURL = `${window.location.origin}/_puppy/`;
        // Local full docker helper
        } else if (window['__XHR_LOCAL__']) {
            options.baseURL = LOCAL_XHR_PUPPY_ENDPOINT;
        // Production goes to the xhr server
        } else {
            options.baseURL = CANONICAL_XHR_PUPPY_ENDPOINT;
        }
    }
    options = yield call(configureOptions, options);
    const fake = yield call(runFake, fakeResponse, options);
    if (fake) {
        return fake;
    }
    return yield call(getApiResponse, options);
}
